// extracted by mini-css-extract-plugin
export default {"list":"styles_list__q73bO","active":"styles_active__u617C"};